/* eslint-disable no-console */
import React, { useState } from "react";
import { TextField, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from "@material-ui/core";
import { criteriaEditProps } from "./CriteriaEdit.d";
import MultiSelect from "../MultiSelect/MultiSelect";
import Button from "jb_component_library/components/Button";
import { usePutCriterias } from "../../api/replenishmentApi";
import { departments, productGroups, seasons } from "../../api/staticData";

const CriteriaEdit: React.FC<criteriaEditProps> = (props) => {
	const {
		criteria
	} = props;
	const [formValues, setFormValues] = useState(criteria);

	const [putCriterias] = usePutCriterias();

	const selectedDepartments = formValues.criterias.departmentIds?.map(m => {
		const o = departments.find(d => d.id.toString() === m);
		return ({id: m, name: o?.name});
	});
	const selectedProductGroups = formValues.criterias.productGroupIds?.map(m => {
		const o = productGroups.find(d => d.id.toString() === m);
		return ({id: m, name: o?.name});
	});
	const selectedSeasons = formValues.criterias.seasonIds?.map(m => {
		const o = seasons.find(d => d.id === m);
		return ({id: m, name: o?.name});
	});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormValues({
		  ...formValues,
		  [name]: value,
		});
	  };
	
	const handleMultiSelectChange = (e, variable) => {
		const vars = formValues.criterias[variable];
		const { name, checked } = e.target;
		const updatedVars = vars.filter(m => m.toString() !== name);
		if(checked) {
			updatedVars.push(name);
		}
		setFormValues({
			...formValues,
			criterias: {
				...formValues.criterias,
				[variable] : updatedVars
			},
		});
	}

	const handleSave = async (e) => {
		putCriterias(formValues)
				.then(() => {
					console.log("Success");
				})
				.catch((e) => {
					console.log(e);
				});
	}

	return (
		<Grid container spacing={4} sx={{border: '1px lightGrey', borderStyle: 'solid', paddingTop: 2, paddingBottom: 2}}>
			<Grid item xs={12} md={3}>
				<Typography variant="h3">Info</Typography>
				<TextField
					id="name"
					name="name"
					label="Name"
					type="text"
					value={formValues.name}
					onChange={handleInputChange}
					variant="outlined"
				/>
			</Grid>
			<Grid item xs={12} md={3}>
				<Grid container direction="column" spacing={2}>
					<Typography variant="h3">Trigger & Action</Typography>
					<Grid item>
						<FormControl>
							<FormLabel id="radio-group-trigger-label">Trigger</FormLabel>
							<RadioGroup
								aria-labelledby="radio-group-trigger-label"
								name="radio-group-trigger"
								value={formValues.trigger}
							>
								<FormControlLabel value="BelowMin" control={<Radio />} label="BelowMin" onChange={handleInputChange} />
							</RadioGroup>
						</FormControl>
					</Grid>
					<Grid item>
						<FormControl>
							<FormLabel id="radio-group-action-label">Action</FormLabel>
							<RadioGroup
								aria-labelledby="radio-group-action-label"
								name="radio-group-action"
								value={formValues.action}
							>
								<FormControlLabel value="OrderToMax" control={<Radio />} label="OrderToMax" onChange={handleInputChange} />
							</RadioGroup>
						</FormControl>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12} md={6}>
				<Grid container direction="column" spacing={2}>
					<Grid item>
						<Typography variant="h3">Products</Typography>
					</Grid>
					<Grid item>
						<MultiSelect
							id="multi-select-departments"
							title="Departments"
							options={departments}
							values={selectedDepartments}
							onSelectionChange={(e) => handleMultiSelectChange(e, 'departmentIds')}
						/>
					</Grid>
					<Grid item>
						<MultiSelect
							id="multi-select-productGroups"
							title="Product Groups"
							options={productGroups}
							values={selectedProductGroups}
							onSelectionChange={(e) => handleMultiSelectChange(e, 'productGroupIds')}
						/>
					</Grid>
					<Grid item>
						<MultiSelect
							id="multi-select-seasons"
							title="Seasons"
							options={seasons}
							values={selectedSeasons}
							onSelectionChange={(e) => handleMultiSelectChange(e, 'seasonIds')}
						/>
					</Grid>
				</Grid>
			</Grid>
			<Grid container item>
				<Button type="primary" onClick={handleSave}>Save</Button>
			</Grid>
		</Grid>
	);
};

export default CriteriaEdit;
